import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'zsd-knowledgebasecontainer',
    templateUrl: './knowledgebasecontainer.component.html',
    styleUrls: ['./knowledgebasecontainer.component.scss']
})

export class KnowledgeBaseContainerComponent implements OnInit {

    ngOnInit() {
    }
}
